import React from 'react';
import { Tabs } from '@mui/material';
import { ArcTabsProps } from './types';

const ArcTabs: React.FC<ArcTabsProps> = (props) => {
  return <Tabs {...props} />;
};

export default ArcTabs;